import styled from 'styled-components';

export const VerticalListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.6rem;
`;
